import React, { Component } from 'react'; 
import { withstyles, Paper, Typography, Button, Radio, RadioGroup, FormControl, FormControlLabel, FormLabel, FormHelperText, checkbox, Divider, withStyles, 
Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Slide, FormGroup, TextField, Checkbox, Grid, Icon } from '@material-ui/core';
import { AssignmentInd, AssignmentLate, AssignmentTurnedIn } from '@material-ui/icons';
import Select from 'react-select';
import fb from '../../config/firebaseConfig';
import db from '../../config/firestoreConfig';

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

const styles = theme => ({
    root: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        position: 'relative',
        margin: 'auto',
        width: '75%',
      },
      container: {
        display: 'block',
        flexWrap: 'wrap',
        padding: 20,
        width: '75%',
        margin: 'auto',
        alignItems: 'center'
      },
      paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
        height: 'auto',
        overflowX: 'auto'
    },
    paper2: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        position: 'relative',
        margin: 'auto',
        width: '100%',
        textAlign: 'center'
    },
      textField: {
        paddingTop: 20,
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '80%',
       
      },
      button: {
        margin: theme.spacing.unit,
        width: 250,
        hieght: 100,
        textAlign: 'left'
      },
      button2: {
        margin: theme.spacing.unit,
      },
      formControl: {
        margin: theme.spacing.unit * 3,
      },
      group: {
        margin: `${theme.spacing.unit}px 0`,
      },
})

class SetHwk extends Component{
    constructor(props){
        super(props)
        this.state = {
            open: false,
            students: [],
            selected:[],
            Groups: [],
            tasks : [],
            GroupMembers: [],
            selectedGroups: [],
            deadline: '',
            selected: [],
            titleError : false,
            deadlineError: false,
            studentError: false,
            isTest: false,
            access: true,
            icons: []
        }
    }

    componentDidMount(){ 
        var tasks = [];
        if (sessionStorage.getItem('AccountType') != 'Teacher') {
            if (sessionStorage.getItem('AccountType') != 'Admin'){
                this.setState({ access: false})
            }
        } 
        db.collection('Level').doc(this.props.match.params.ref).collection('Subjects').doc(this.props.match.params.subject).collection('Years').doc(this.props.match.params.year).collection('Abilities').doc(this.props.match.params.ability).get()
            .then( snapshot => {
                this.setState({
                    subject : snapshot.data().data
                })
                //console.log(snapshot.data())
                snapshot.data().data.Classes.forEach(Group => {
                    //console.log(Group)
                    db.collection('WorkGroups').where('name', '==', Group).get()
                        .then(snapshot => {
                            //console.log(snapshot.docs)
                            snapshot.docs.forEach(doc => {
                                var groupDropDown = []
                                //console.log('success: ' + doc.data().name)
                                var memberList = doc.data()
                                //console.log('71: ' , doc.data())
                                memberList.Members.forEach(member => { 
                                    groupDropDown.push({
                                        name: member.Name,
                                        value: member.uid,
                                        label: member.Name
                                    })
                                })
                                this.state.Groups.push({
                                    label: doc.data().name,
                                    value: groupDropDown,
                                    name: doc.data().name
                                }) 
                                //console.log('the state: ', this.state) //Debug line
                            })
                        })
                })
                
            })
            //fill the student arr the long way as delete students isnt completed yet so this is the easiest/most thorough way to check
        db.collection('Users').where('CurrentYear', '==', this.props.match.params.year).get()
            .then(snapshot => { 
                let arr = this.state.students;
                snapshot.docs.forEach(doc => {
                    // //console.log(doc.data()) //debug line
                    arr.push(
                        {
                            label: doc.data().displayName,
                            value: doc.data().UID,
                            name: doc.data().displayName,
                        }
                    )
                })
                this.setState({
                    students: arr
                })
                // //console.log(this.state)
            })

        // db.collection('Tests').get()
        // .then(snapshot => { 
        //     snapshot.forEach(task => { 
        //         this.state.tasks.push({task: task.id, data: task.data()})
        //     })
        // })
    }

    handleCheck = (opt, meta)  => {
        // console.log('handle Check started')
        // console.log(opt, meta)
        var arr = []
        opt.forEach(student => { 
            arr.push(student)
        })
        console.log(arr)
        this.setState({selected: arr})
    }


    handleGroupCheck = (opt, meta) => { 
        console.log('started')
        console.log(opt, meta) 
        if (meta.action == 'select-option'){
            var studentArr = opt[opt.length-1].value;
            var selectedArr = this.state.selected;
            console.log(studentArr)
            studentArr.forEach( member => {
                    if (!selectedArr.includes(member)){
                        console.log('adding element')
                        console.log('array doesnt include student already')
                        selectedArr.push(member)
                        console.log(selectedArr)
                        const state = {
                            ...this.state,
                            selected: selectedArr
                        }
                        this.setState(state)
                    }
            })
        }
         else if (meta.action == 'remove-value'){
             console.log(opt, meta, meta.action)
             var selectedArr = this.state.selected;
             var idsToRemove  = []
             meta.removedValue.value.forEach(student => { 
                 if (selectedArr.includes(student)){
                     selectedArr.splice(selectedArr.indexOf(student), 1)
                 }
             })
             //console.log(selectedArr)
             this.setState({selected : selectedArr})
         }   
    }



    handleClick = (name, section) => { 
        this.setState({
            ...this.state,
            open: true,
            currentHwk: name,
            section: section
        })

    }

    handleClickTest = (name, section) => { 
        //console.log('289', 'test clicked', name)
        this.setState({
            ...this.state,
            open: true,
            isTest: true,
            currentHwk: name,
            section: section
        })

    }

    handleClose = () => {
        this.setState({
            open: false
        })
    }

    handleChange = (name) => event => { 
        this.setState({
            ...this.state,
            deadlineError: false,
            [name]: event.target.value
        })
        //console.log(this.state)
    }

    setTask = async () => {
        const title = this.state.currentHwk;
        var thisTest = await db.collection('AssignedTasks').doc(title).get()
        const deadline = this.state.deadline;
        const comparisonDate = new Date(deadline)
        const students = this.state.selected;
        var currentlyAssigned = []
        //console.log(this.state.selected)
        //console.log(comparisonDate, new Date(), comparisonDate.getTime() < new Date().getTime())
        if (title.length == 0){ 
            return window.alert('This is an invalid Task due to lack of a title. Please report to an admin')
        } else if (deadline.length == 0 || comparisonDate.getTime() < new Date().getTime()) {
            return this.setState({deadlineError : true })
        } else if ( students.length == 0) { 
             this.setState({studentError : true })
             return window.alert('Please select students to assign the work to')
        }
        
        //console.log(thisTest.data(), thisTest)
        if (thisTest.data()) {
             currentlyAssigned = thisTest.data().AssignedTo
        } else {
            currentlyAssigned = []
        }
        students.forEach(student => { 
            currentlyAssigned.push({
                'Student': student.value,
                'Score': 0,
                'CompletionDate': 'N/A',
                'displayName': student.name
            })
        })
        //console.log(currentlyAssigned)
        const finalObj = {
            'AssignedTo': currentlyAssigned,
            'Deadline': deadline,
            'Test': this.state.isTest,
            'Level': this.props.match.params.ref,
            'Year': this.props.match.params.year,
            'Ability': this.props.match.params.ability,
            'Section': this.state.section,
            'Subject': this.props.match.params.subject
        }
        //console.log('289', finalObj)
        db.collection('AssignedTasks').doc(title).set(finalObj, {merge: true})
            .then(() => {
                window.alert('Task ' + title + ' saved ')
                this.reset()
            })
            .catch((error) => {
                window.alert('There was an error setting the task: ' + error)
                //console.log(error)
            })
    }

    reset = () => { 
        this.setState({ 
            ...this.state, 
            open: false,
            students: this.state.students,
            Groups: this.state.Groups,
            selectedGroups: [],
            selected: [],
            deadline: '',

        })
    }

    evaluate = title => { 
        // //console.log('TITLE', title, this.state.tasks)
        var output = []
        db.collection('AssignedTasks').doc(title).get()
        .then(function(doc){
            if (doc.exists) {
                //console.log('DATA', doc.data())
                var deadline = new Date(doc.data().Deadline).valueOf()
                //console.log(deadline)
                doc.data().AssignedTo.forEach(s => { 
                    if (s.Student == this.props.match.params.id){
                        if (s.CompletionDate == 'N/A'){
                            if (deadline < new Date().valueOf()){
                                output.push(1)
                                //console.log('OUTPUT', output, title)
                                var final = {title: title, value: output[0]}
                                //console.log('FINAL', final)
                                var add = true
                                this.state.icons.forEach(icon => { 
                                    if (icon.title == title){
                                        //console.log('ALREADY EXISTS', icon.title, title, this.state.icons)
                                        add = false
                                    }
                                })
                                if (add) {
                                    //console.log('WE PUSHIN')
                                    var toSet = this.state.icons
                                    toSet.push(final)
                                    this.setState({
                                        ...this.state,
                                        icons : toSet
                                    })
                                }
                            } else {
                                output.push(2)
                                //console.log('OUTPUT', output, title)
                                var final = {title: title, value: output[0]}
                                //console.log('FINAL', final)
                                var add = true
                                this.state.icons.forEach(icon => { 
                                    if (icon.title == title){
                                        //console.log('ALREADY EXISTS', icon.title, title, this.state.icons)
                                        add = false
                                    }
                                })
                                if (add) {
                                    //console.log('WE PUSHIN')
                                    var toSet = this.state.icons
                                    toSet.push(final)
                                    this.setState({
                                        ...this.state,
                                        icons : toSet
                                    })
                                }
                            }
                        } else
                        if (new Date(s.CompletionDate).valueOf() <  deadline){
                            //console.log('ONTIME')
                            output.push(3)
                            //console.log('OUTPUT', output, title)
                            var final = {title: title, value: output[0]}
                            //console.log('FINAL', final)
                            var add = true
                            this.state.icons.forEach(icon => { 
                                if (icon.title == title){
                                    //console.log('ALREADY EXISTS', icon.title, title, this.state.icons)
                                    add = false
                                }
                            })
                            if (add) {
                                //console.log('WE PUSHIN')
                                var toSet = this.state.icons
                                toSet.push(final)
                                this.setState({
                                    ...this.state,
                                    icons : toSet
                                })
                            }
                        } else {
                            //console.log('LATE')
                            output.push(1)
                            //console.log('OUTPUT', output, title)
                            var final = {title: title, value: output[0]}
                            //console.log('FINAL', final)
                            var add = true
                            this.state.icons.forEach(icon => { 
                                if (icon.title == title){
                                    //console.log('ALREADY EXISTS', icon.title, title, this.state.icons)
                                    add = false
                                }
                            })
                            if (add) {
                                //console.log('WE PUSHIN')
                                var toSet = this.state.icons
                                toSet.push(final)
                                this.setState({
                                    ...this.state,
                                    icons : toSet
                                })
                                
                            }
                        }
                    }
                })
            }
        }.bind(this))
    }

    render(){
        const { classes } = this.props
        return (
            <div className={classes.root}>
                {(this.state.subject) ? (
                <Paper className={classes.root} elevation={1}>
                    <div className={classes.paper2}>
                    <Typography variant='headline'>  
                            Content Section for 
                            {sessionStorage.getItem('AccountType') == 'Student' ?
                                <Typography variant='subheading' style={{ display: 'inline-block', right: 0, textAlign: 'left', float: 'right', overflow: 'hidden', zoom: 1, marginLeft: 20, marginRight: 20}}>
                                    Key for task status: <br/> <Divider/> <br/> <AssignmentInd/>   Set <br/> <AssignmentLate/>   Late <br/> <AssignmentTurnedIn/>   Completed
                                </Typography>
                            :
                                <br/>
                            }
                        </Typography>
                        <Button className={classes.button2} variant='outlined' onClick={() => {window.location.replace('/' + this.props.match.params.id + '/levels/' + this.props.match.params.ref)}}>
                            {this.props.match.params.ref}
                        </Button>
                            - 
                        <Button className={classes.button2} variant='outlined' onClick={() => {window.location.replace('/' + this.props.match.params.id + '/levels/' + this.props.match.params.ref + '/' + this.props.match.params.subject)}}>
                            {this.props.match.params.subject}
                        </Button>
                            - 
                        <Button className={classes.button2} variant='outlined'  onClick={() => {window.location.replace('/' + this.props.match.params.id + '/levels/' + this.props.match.params.ref + '/' + this.props.match.params.subject + '/' + this.props.match.params.year)}}>
                            {'Year ' + this.props.match.params.year}
                        </Button>
                            -
                        <Button className={classes.button2} variant='outlined' color='secondary'>
                            {this.props.match.params.ability}
                        </Button>
                    </div>
                    <br/>
                    <Divider/>
                    <Grid container
                            spacing={24}
                            direction='row'
                            justify='space-evenly'
                            alignContent='left'
                    >
                        <div className={classes.container}>
                            {this.state.subject.Content.Sections.map(section => {
                                section.HWK.map(test => { 
                                    this.evaluate(test)
                                })
                                return ( 
                                    <div>
                                    <Paper className={classes.container}>
                                    {/* // <div style={{display: 'block', width: '30%'}}> */}
                                        <Typography variant='title' style={{width: '100%'}}>    
                                            {section.Name}
                                        </Typography>
                                        
                                        <Divider/>
                                        <br/>
                                        {this.state.access ? 
                                            section.HWK.map(hwk => {
                                                return (
                                                    <Grid item xs={4}>
                                                        <Button variant='outlined' className={classes.button} onClick={() => this.handleClick(hwk, section.Name)}>
                                                            <div style={{ width: '100%' }}>
                                                                {hwk}
                                                            </div>
                                                        </Button>
                                                    </Grid>
                                                    
                                                )
                                            })
                                            
                                        :
                                            section.HWK.map(hwk => {
                                                return (
                                                    <Grid item xs={4}>
                                                        <Button variant='outlined'  className={classes.button} >
                                                            <div style={{ width: '100%' }}>
                                                                {hwk}
                                                                {this.state.icons.map(icon => {
                                                                    if (icon.title == hwk){
                                                                        if (icon.value == 2){
                                                                            return (<AssignmentInd  style={{float: 'right', alignSelf: 'right', alignContent: 'right'}}/>)
                                                                        } else if (icon.value == 1){ 
                                                                            return (<AssignmentLate style={{float: 'right', alignSelf: 'right', alignContent: 'right'}}/>)
                                                                        } else if (icon.value == 3){
                                                                            return (<AssignmentTurnedIn  style={{float: 'right', alignSelf: 'right', alignContent: 'right'}}/>)
                                                                        }
                                                                    }
                                                                }
                                                                )}
                                                            </div>
                                                        </Button>
                                                    </Grid>
                                                    
                                                )
                                            })

                                        }
                                    </Paper>
                                    <br/>
                                    </div>
                                )
                            })}
                        </div>
                    </Grid>
                </Paper> )
                : (
                <div></div>
                )}
                <br/>
                {(this.state.subject) ? (
                <Paper className={classes.root} elevation={1}>
                    <div className={classes.paper2}>
                        <Typography variant='headline'>  
                            Content Section tests for
                            {sessionStorage.getItem('AccountType') == 'Student' ?
                                <Typography variant='subheading' style={{ display: 'inline-block', right: 0, textAlign: 'left', float: 'right', overflow: 'hidden', zoom: 1, marginLeft: 20, marginRight: 20}}>
                                    Key for task status: <br/> <Divider/> <br/> <AssignmentInd/>   Set <br/> <AssignmentLate/>   Late <br/> <AssignmentTurnedIn/>   Completed
                                </Typography>
                            :
                                <br/>
                            }
                        </Typography>
                        <Button className={classes.button2} variant='outlined' onClick={() => {window.location.replace('/' + this.props.match.params.id + '/levels/' + this.props.match.params.ref)}}>
                            {this.props.match.params.ref}
                        </Button>
                            - 
                        <Button className={classes.button2} variant='outlined' onClick={() => {window.location.replace('/' + this.props.match.params.id + '/levels/' + this.props.match.params.ref + '/' + this.props.match.params.subject)}}>
                            {this.props.match.params.subject}
                        </Button>
                            - 
                        <Button className={classes.button2} variant='outlined'  onClick={() => {window.location.replace('/' + this.props.match.params.id + '/levels/' + this.props.match.params.ref + '/' + this.props.match.params.subject + '/' + this.props.match.params.year)}}>
                            {'Year ' + this.props.match.params.year}
                        </Button>
                            -
                        <Button className={classes.button2} variant='outlined' color='secondary'>
                            {this.props.match.params.ability}
                        </Button>
                    </div>
                    <Divider/>
                    <Grid container
                            spacing={24}
                            direction='row'
                            justify='space-evenly'
                            alignContent='left'
                    >
                        <div className={classes.container}>
                            {this.state.subject.Content.Sections.map(section => {
                                section.Tests.map(test => { 
                                    this.evaluate(test)
                                })
                                return ( 
                                    <div>
                                    <Paper className={classes.container}>
                                    {/* // <div style={{display: 'block', width: '30%'}}> */}
                                        <Typography variant='title' style={{width: '100%'}}>
                                            {section.Name}
                                        </Typography>
                                        
                                        <Divider/>
                                        <br/>
                                        {this.state.access ? 
                                            section.Tests.map(test => {
                                                return (
                                                    <Grid item xs={4}>
                                                        <Button variant='outlined' className={classes.button} onClick={() => this.handleClickTest(test, section.Name)}>
                                                            <div style={{ width: '100%' }}>
                                                                {test}
                                                            </div>
                                                        </Button>
                                                    </Grid>
                                                )
                                                
                                            })
                                            :
                                            section.Tests.map(test => {
                                                return (
                                                    <Grid item xs={4}>
                                                        <div style={{width: '100%'}}>
                                                            <Button variant='outlined' className={classes.button}>
                                                                <div style={{width: '100%'}}>
                                                                    {test}
                                                                    {this.state.icons.map(icon => {
                                                                    if (icon.title == test){
                                                                        if (icon.value == 2){
                                                                         return (<AssignmentInd  style={{float: 'right', alignSelf: 'right', alignContent: 'right'}}/>)
                                                                         } else if (icon.value == 1){ 
                                                                          return (<AssignmentLate  style={{float: 'right', alignSelf: 'right', alignContent: 'right'}}/>)
                                                                        } else if (icon.value == 3){
                                                                            return (<AssignmentTurnedIn  style={{float: 'right', alignSelf: 'right', alignContent: 'right'}}/>)
                                                                        }        
                                                                    }
                                                                    }
                                                                    )}
                                                                </div>
                                                            </Button>
                                                            
                                                        </div>
                                                    </Grid>
                                                )
                                                
                                            })
                                        }
                                    
                                    </Paper>
                                    <br/>
                                    </div>
                                    
                                )
                            })}
                        </div>
                    </Grid>
                </Paper> )
                : (
                <div></div>
                )}
                <Dialog
                    open={this.state.open}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={this.handleClose}
                    aria-labelledby='form-dialog-title'
                >
                <DialogTitle id='form=dialog-title'> Assign task</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Pleae assign a completion date for the task
                    </DialogContentText>
                    <form className={classes.container}>
                        <TextField
                            id='date'
                            label='Completion Deadline'
                            type='date'
                            error={this.state.deadlineError}
                            value={this.state.deadline}
                            onChange={this.handleChange('deadline')}
                            className={classes.textField}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </form>
                    <br/>
                    <FormControl compoent='fieldset' className={classes.textField}>
                            {this.state.students.length > 0 ? (
                            <div>
                                <FormLabel component='legend'>Which students to assign work to</FormLabel>
                                <Divider/>
                                <br/>
                                <Select 
                                    options={this.state.students} 
                                    maxMenuHeight={150}
                                    isMulti
                                    onChange={(opt, meta) => this.handleCheck(opt, meta)}
                                />
                            </div>
                            ) : 
                            (
                                <div>
                                    <FormLabel component='legend'>You have no students in this class to assign to</FormLabel>
                                    <br/>
                                    <Button variant='contained' className={classes.button} onClick={() => this.doNothing()}>
                                        Create Students?
                                    </Button>
                                </div>
                            )}
                    </FormControl>
                    <br/>
                    <FormControl compoent='fieldset' className={classes.textField}>
                            {this.state.Groups.length > 0 ? (
                            <div>
                                <FormLabel component='legend'>Which Groups to assign work to</FormLabel>
                                <Select 
                                    options={this.state.Groups} 
                                    maxMenuHeight={150}
                                    isMulti
                                    onChange={(opt, meta) => this.handleGroupCheck(opt, meta)}
                                />
                            </div>
                            ) : 
                            (
                                <div>
                                    <FormLabel component='legend'>You have no Work Groups in this class to assign to</FormLabel>
                                    <br/>
                                    <Button variant='contained' className={classes.button} onClick={() => window.location.replace('/' + this.props.match.params.id + '/groups/create')}>
                                        Create Groups?
                                    </Button>
                                </div>
                            )}
                    </FormControl>
                    <Divider/>
                    <br/>
                    <Button variant='contained' className={classes.button} onClick={() => this.setTask()}>
                        Set Task
                    </Button>
                    
                </DialogContent>
                </Dialog>
            </div>
        ) 
    }
}
export default withStyles(styles)(SetHwk);


// WEBPACK FOOTER //
// ./src/pages/Create/subject.jsx